import { animateScroll as scroll } from "react-scroll";

const scrollToTop = () => {
	scroll.scrollToTop();
};

export default scrollToTop;
